var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpdeskSolve(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.02632 13.9825C0.752631 13.9825 0.513158 13.8777 0.307895 13.6679C0.102632 13.4582 0 13.2135 0 12.9338V1.04869C0 0.769039 0.102632 0.524345 0.307895 0.314607C0.513158 0.104869 0.752631 0 1.02632 0H6.8421L10.9474 4.19476V8.91386H9.92105V4.89388H6.15789V1.04869H1.02632V12.9338H8.03947V13.9825H1.02632Z",
    fill: "#3C419A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51458 10.7458L8.56979 6.69062L7.87917 6L4.51458 9.36458L2.69062 7.54063L2 8.23125L4.51458 10.7458Z",
    fill: "#3C419A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16C11.1658 16 10.4572 15.7112 9.87433 15.1337C9.29144 14.5561 9 13.8503 9 13.016C9 12.1818 9.29144 11.4706 9.87433 10.8824C10.4572 10.2941 11.1658 10 12 10C12.8342 10 13.5428 10.2941 14.1257 10.8824C14.7086 11.4706 15 12.1818 15 13.016C15 13.8503 14.7086 14.5561 14.1257 15.1337C13.5428 15.7112 12.8342 16 12 16ZM10.1872 13.2727H13.8128V12.631H10.1872V13.2727Z",
    fill: "#3C419A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpdeskSolve);
export default __webpack_public_path__ + "static/media/helpdesk-solve.29a41a83630fa65bcc2ef02fb72d524c.svg";
export { ForwardRef as ReactComponent };